import { Alert, Conditional, Container, IconShare2, Text } from '@consumidor-positivo/aurora';

import { UserType } from '../../../../lib/types';

import { Share } from './components/Share';
import { AnnualFee } from './components/AnnualFee';
import { ExpenseInfo } from './components/ExpenseInfo';
import { EditExpense } from './components/EditExpense';
import { SearchConfig } from './components/SearchConfig';
import { OrderFilters } from './components/OrderFilters';
import { BenefitsFilter } from './components/BenefitsFilter';
import { ResultCarousel } from './components/ResultCarousel';

import './styles.scss';
import { useMMResult } from './hook';

export type MMResultProps = {
  token: string;
  user: UserType;
  clearForm: () => void;
};
export const MMResult = (props: MMResultProps) => {
  const {
    orderBy,
    showShare,
    isLoading,
    orderedList,
    editExpense,
    annualFilter,
    benefitFilter,
    userFirstName,
    monthlyExpense,
    orderResult,
    toggleShare,
    updateFilters,
    toggleEditExpense,
  } = useMMResult(props);

  return (
    <div className="mm-result">
      <div className="mm-result__search">
        <SearchConfig>
          <div className="mm-result__form-info">
            <ExpenseInfo monthlyExpense={monthlyExpense} openEditModal={toggleEditExpense} />
            <AnnualFee annualFilter={annualFilter} changeAnnualFilter={() => updateFilters({ annuity: !annualFilter })} />
          </div>
        </SearchConfig>
      </div>

      <Container customClass="mm-result__header">
        <div className="mm-result__header-info">
          <Text as="h3" variant="heading-large" weight="bold">
            {userFirstName},
          </Text>
          <Conditional
            condition={isLoading}
            renderIf={
              <Text as="p" variant="body-large">
                Buscando informações de <strong>cartões</strong>
              </Text>
            }
            renderElse={
              <Text as="p" variant="body-large">
                Encontramos{' '}
                <strong>
                  {orderedList?.length} {orderedList?.length === 1 ? 'cartão' : 'cartões'}
                </strong>{' '}
                com base no seu perfil
              </Text>
            }
          />
        </div>
        <div className="mm-result__form-info mm-result__form-info--desktop">
          <ExpenseInfo monthlyExpense={monthlyExpense} openEditModal={toggleEditExpense} />
          <AnnualFee annualFilter={annualFilter} changeAnnualFilter={() => updateFilters({ annuity: !annualFilter })} />
        </div>
      </Container>

      <div className="mm-result__separator" />

      <Container customClass="mm-result__filters">
        <OrderFilters selectedOrder={orderBy} onChangeOrder={orderResult} benefitFilter={benefitFilter} />
        <div className="mm-result__share" onClick={toggleShare}>
          <IconShare2 />
        </div>
      </Container>

      <Container customClass="mm-result__carousel">
        <ResultCarousel isLoading={isLoading} offers={orderedList} user={props.user} />
      </Container>

      <Container customClass="mm-result__disclaimer">
        <Alert
          status="info"
          title={{ content: 'A liberação de crédito é feita pelo parceiro', weight: 'bold' }}
          text="Nós avaliamos as suas chances de aprovação através de seus dados, mas não é uma garantia."
          orientation="vertical"
        />
      </Container>

      <div className="mm-result__benefits">
        <Container>
          <BenefitsFilter selectedBenefit={benefitFilter} onChangeFilter={updateFilters} clearForm={props.clearForm} />
        </Container>
      </div>
      <EditExpense isOpen={editExpense} monthlyExpense={monthlyExpense} toggleModal={toggleEditExpense} onSubmit={updateFilters} />
      {/* SHARE IS FROM MM LEGACY. */}
      <Share
        showShare={showShare}
        title="Compartilhar Match Positivo"
        message="Você prefere ganhar milhas ou cashback? Descubra seu cartão de crédito ideal na Consumidor Positivo."
        url={'https://app.consumidorpositivo.com.br/comparador-v2'}
        onClose={toggleShare}
      />
    </div>
  );
};
